module.exports = __webpack_public_path__ + "static/media/NAININTHallwayA0003_bg_clean_v001.bddf4163.webp";